<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  'search': [query: string]
  'close': []
}>()

const searchQuery = ref('')

function handleInput() {
  emit('search', searchQuery.value)
}

function clearSearch() {
  searchQuery.value = ''
  emit('search', '')
}

function handleClose() {
  emit('close')
}
</script>

<template>
  <div
    class="search-container bg-card border-b border-border transition-all duration-300 overflow-hidden"
    :class="isOpen ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div class="search-box relative">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="搜索书签..."
          class="w-full px-4 py-2 pl-10 pr-10 bg-input border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-foreground placeholder:text-muted-foreground"
          @input="handleInput"
          @keyup.esc="handleClose"
        >
        <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"></i>
        <button
          v-if="searchQuery"
          class="btn-icon absolute right-2 top-1/2 -translate-y-1/2"
          @click="clearSearch"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</template>
